<template>
  <TableLayout :permissions="['business:banner:query']">
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="标题" prop="title">
        <el-input v-model="searchForm.title" clearable placeholder="请输入标题" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:banner:create']">
        <li><el-button type="primary" @click="$refs.operaBannerEditWindow.open('新建轮播图',null,searchForm.type)" icon="el-icon-plus" v-permissions="['business:banner:create']">新建</el-button></li>
      </ul>
      <el-table
        :height="tableHeightNew"
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
      >
        <el-table-column prop="title" label="标题" min-width="120px"></el-table-column>
        <el-table-column prop="position" label="展示位置" min-width="100px">
          <template slot-scope="{row}">
            {{ positionOptions[row.position] || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="图片" min-width="120px">
          <template slot-scope="{row}">
            <el-image
              v-if="row.imgurlFull"
              style="width: 80px; height: 40px"
              :src="row.imgurlFull"
              :preview-src-list="[row.imgurlFull]"
              fit="contain"
            ></el-image>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="跳转方式" min-width="100px">
          <template slot-scope="{row}">
            {{ jumpTypeOptions[row.type] || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="sortnum" label="排序码" min-width="80px"></el-table-column>
        <el-table-column label="状态" min-width="80px">
          <template slot-scope="{row}">
            <el-switch
              @change="handleStatusChange($event, row)"
              v-model="row.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="0"
              :inactive-value="1"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="修改时间" min-width="160px"></el-table-column>
        <el-table-column label="操作" min-width="150" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaBannerEditWindow.open('编辑轮播图', row,searchForm.type)" >编辑</el-button>
            <el-button type="text" style="color: red;" @click="deleteById(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      ></pagination>
    </template>
    <OperaBannerEditWindow ref="operaBannerEditWindow" @success="handlePageChange" />
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaBannerEditWindow from '@/components/business/OperaBannerEditWindow'
export default {
  name: 'BannerList',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaBannerEditWindow },
  data () {
    return {
      positionOptions: {
        0: '会员端首页轮播',
        1: '司机APP引导页'
      },
      jumpTypeOptions: {
        0: '无',
        1: '富文本',
        2: '外链'
      },
      searchForm: {
        title: ''
      }
    }
  },
  created () {
    this.config({
      api: '/business/banner',
      'field.id': 'id'
    })
    this.search()
  },
  methods: {
    handleStatusChange (val, row) {
      this.api.updateStatus({ id: row.id, status: val }).then(res => {
        this.$tip.apiSuccess(res || '修改成功')
      }).catch(e => {
        row.status = val === 1 ? 0 : 1
        this.$tip.apiFailed(e)
      })
    }
  }
}
</script>
